import React from "react";
import { Card, CardValue } from "../types/game";
import { CardTheme } from "./types";
import { NumberSymbol } from "./symbols/NumberSymbol";
import { SkipSymbol } from "./symbols/SkipSymbol";
import { ReverseSymbol } from "./symbols/ReverseSymbol";
import { Draw2Symbol } from "./symbols/Draw2Symbol";
import { WildSymbol } from "./symbols/WildSymbol";
import { Wild4Symbol } from "./symbols/Wild4Symbol";

interface CardSymbolProps {
  card: Card;
  theme: CardTheme;
}

export const CardSymbol: React.FC<CardSymbolProps> = React.memo(({ card, theme }) => {
  if (typeof card.value === "number") {
    return <NumberSymbol value={card.value} theme={theme} />;
  }

  switch (card.value) {
    case CardValue.SKIP:
      return <SkipSymbol theme={theme} />;
    case CardValue.REVERSE:
      return <ReverseSymbol theme={theme} />;
    case CardValue.DRAW2:
      return <Draw2Symbol theme={theme} />;
    case CardValue.WILD:
      return <WildSymbol theme={theme} />;
    case CardValue.WILD4:
      return <Wild4Symbol theme={theme} />;
    default:
      // Exhaustive check - TypeScript will error if we miss a case
      const _exhaustive: never = card.value;
      return null;
  }
});

CardSymbol.displayName = "CardSymbol";
